<template>
  <div class="home">
    <CustomText tag="h1">Profile IGTV</CustomText>
  </div>
</template>

<script>
import CustomText from "@/components/CustomText";
export default {
  name: "ProfileIGTV",
  components: {
    CustomText,
  },
};
</script>
